import { Flex, Tooltip } from '@brightdrop/bd-ui';
import { IconButton, Typography } from '@mui/material';

import InfoIcon from '~/assets/icons/new/infoIcon.svg?react';

import type { OverviewDetailsProps } from './types';

type OverviewFieldLabelProps = {
  field: OverviewDetailsProps;
  testId: string;
  className: string;
  typographyVariant: 'body_regular' | 'small_body_regular';
};

/**
 * Field label with its optional tooltip trigger, shared by the grid and list
 * field layouts so both keep the same markup and test ids.
 */
const OverviewFieldLabel = ({
  field,
  testId,
  className,
  typographyVariant,
}: OverviewFieldLabelProps): JSX.Element => (
  <Flex
    gap={4}
    className={className}
    dataTestId={`${field.testid}-${testId}-overview-label`}
    style={{ alignItems: 'center' }}
  >
    <Typography variant={typographyVariant}>{field.label}</Typography>
    {field.labelIcon}
    {field.tooltip && (
      <Tooltip
        content={field.tooltip}
        trigger={
          <IconButton
            size="small"
            data-testid={`${field.testid}-${testId}-tooltip-icon`}
            aria-label={field.label}
          >
            <InfoIcon />
          </IconButton>
        }
        placement="top"
        showArrow={true}
      />
    )}
  </Flex>
);

export default OverviewFieldLabel;
